const defaultErrorState = {
	email: {
		type: '',
		message: '',
	},
};

export default defaultErrorState;
